import React from 'react';

const Textfiled = (props) => {
  const {
    type,
    value,
    className,
    placeholder,
    disabled,
    defaultValue,
    onChange,
    onBlur,
    name
  } = props;

  return (
    <div className="input_fields">
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        defaultValue={defaultValue}
        className={className}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        name={name}
      />
    </div>
  );
};

export default Textfiled;
